import React, { useState } from "react";
import { connect } from "react-redux";
import { WheelContainerStyled, Table, ImagePreloadContainer } from "./styled";
import { adminService } from "apiService";
import { setReduxUserAuth } from "actions";
import { Helmet } from "react-helmet";
import { ButtonCustom, SideContainer, CreatorIcon, Modal } from "components";
import { CreatorServiceForm } from "forms/AdminFormSystem";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import WheelCreator from "../WheelComponent/WheelCreator";
import WheelDetail from "../WheelComponent/WheelDetail";

class WheelContainer extends React.Component {
  state = {
    data: [],
    isOpenSideContainer: false,
    initialValues: null,
    type: null,
    isModal: false,
    dataServiceList: [],
    sidePanelTitle: "New Wheel",
    sidePanelComponents: null,
    wheelData: {},
    creatorData: [],
    showCreatorData: false,
    wheelDetailSubmit: () => { },
    wheelDetailCancel: () => { },
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await adminService.GET_WHEEL_LIST();
    if (res && res.success) {
      this.setState({
        data: res.data,
      });
    }
  };

  createWheel = async (event) => {
    event.preventDefault();

    const form = { ...event };

    const data = this.createBodyDataForService(form);

    const { success } = await adminService.POST_WHEEL_LIST(data);
    if (success) {
      toast.success("สำเร็จ");
    } else {
      toast.error("ไม่สำเร็จ");
    }
  };

  handleCreateWheel = () => {
    this.setState({
      wheelData: {},
      sidePanelTitle: "Create Wheel",
      creatorData: [],
      showCreatorData: false,
      wheelDetailSubmit: this.createWheel,
      wheelDetailCancel: this.onCloseSidePanel,
    });

    this.onOpenSidePanel();
  };

  onOpenSidePanel = () => {
    this.setState({
      isOpenSideContainer: true,
    });
  };

  onCloseSidePanel = () => {
    this.setState({
      isOpenSideContainer: false,
    });
  };

  removeCreatorFromWheel = async (wheel_slug, creator_id) => {
    const { success } = await adminService.DELETE_CREATOR_WHEEL(
      wheel_slug,
      creator_id
    );
    if (success) {
      toast.success("ยกเลิกสำเร็จ");
      this.handleLoadWheel()
    } else {
      toast.error("ยกเลิกไม่สำเร็จ");
    }
  };

  removeCreatorFromWheelHandler = (wheel_slug, creator_id) => {
    confirmAlert({
      title: "Confirm to toggle",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.removeCreatorFromWheel(wheel_slug, creator_id)
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleLoadWheel = async () => {
    const { wheelData } = this.state
    const res = await adminService.GET_CREATOR_WHEEL(wheelData.slug);
    if (res.success) {
      this.fetchData()
      this.setState({
        creatorData: res.data,
      });

    }
  };

  createBodyDataForService = (form) => {
    const data = {};

    for (let i = 0; i < form.target.length; i++) {
      const { type, name, value, checked } = form.target[i];
      if (type === "text") {
        data[name] = value;
      } else if (type === "number") {
        data[name] = parseFloat(value);
      } else if (type === "checkbox") {
        data[name] = checked;
      }
    }

    return data;
  };

  updateWheel = async (event, slug) => {
    event.preventDefault();

    const form = { ...event };

    const data = this.createBodyDataForService(form);

    const { success } = await adminService.PATCH_WHEEL_UPDATE(slug, data);
    if (success) {
      toast.success("สำเร็จ");
    } else {
      toast.error("ไม่สำเร็จ");
    }
  };

  handleClickWheel = async (wheelData) => {
    const { success, data } = await adminService.GET_CREATOR_WHEEL(
      wheelData.slug
    );

    if (success) {
      this.setState({
        wheelData: wheelData,
        sidePanelTitle: "Wheel Detail",
        creatorData: data,
        wheelDetailSubmit: this.updateWheel,
        wheelDetailCancel: this.onCloseSidePanel,
        showCreatorData: true,
      });

      this.onOpenSidePanel();
    }
  };

  fetchCreatorService = async (e) => {
    let res = await adminService.GET_CREATOR_SERVICES_LIST(e);

    if (res && res.success) {
      let data = [{ label: 'ไม่ระบุ', value: 'null' }]
      res.data.map((e) => (
        data.push({
          value: e.id,
          label: e.name
        })
      ))
      this.setState({
        isModal: true,
        creatorID: e,
        dataServiceList: data,
      });
    }
  };

  handleClickCloseModal = () => {
    this.setState({
      isModal: false,
    });
  };

  handleCreateService = async () => {
    const {
      reduxForm2: { values, syncErrors },
    } = this.props;
    const {
      creatorID,
      wheelData,
    } = this.state;

    if (typeof syncErrors === "object") {
      toast.error("กรุณาเลือกข้อมูลด้วย", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      let params

      if (values.slug === 'null') {
        params = {
          id: creatorID,
        };

      } else {
        params = {
          id: creatorID,
          service_id: values.slug
        };
      }

      let res = await adminService.POST_CREATOR_WHEEL(wheelData.slug, params);

      if (res && res.success) {
        toast.success("บันทึกสำเร็จ");
        this.fetchData();
        this.handleLoadWheel();
        this.setState({
          isModal: false,
        })
      } else {
        toast.error("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      }
    }
  };

  render() {
    const {
      data,
      creatorData,
      showCreatorData,
      wheelData,
      sidePanelTitle,
      isOpenSideContainer,
      wheelDetailSubmit,
      wheelDetailCancel,
      isModal,
      dataServiceList,
    } = this.state;
    return (
      <WheelContainerStyled>
        <Helmet>
          <title>admin</title>
        </Helmet>

        <>
          <div className="tab_layout">
            <div className="title_layout">Wheel System</div>
            <div className="button_layer">
              <ButtonCustom
                theme_yellow_2
                label="+ New Wheel"
                onClick={this.handleCreateWheel}
              />
            </div>
          </div>

          <div className="content">
            <Table>
              {data?.map((value, index) => (
                <label
                  className="genre-wrapper"
                  key={index}
                  onClick={() => this.handleClickWheel(value)}
                >
                  <div className="genre-container">
                    <ImageWithPreload src={value.poster_photo_uri} />
                    <div className="overlay">
                      <span className="genre-name">{value.title}</span>
                      <div className="creator-count-container">
                        <CreatorIcon fill="white" />
                        <span className="count">
                          {value.creators_count.toLocaleString()}
                        </span>
                      </div>
                    </div>
                    <span className="ordering-number">#{value.order}</span>
                  </div>
                </label>
              ))}
            </Table>
          </div>
        </>

        <SideContainer
          title={sidePanelTitle}
          isShow={isOpenSideContainer}
          handleClose={() => this.onCloseSidePanel()}
        >
          <WheelDetail
            wheelData={wheelData}
            onSubmit={wheelDetailSubmit}
            onCancel={wheelDetailCancel}
            isShow={isOpenSideContainer}
          />

          <br />
          <div className="seperate-line" />
          <br />

          <WheelCreator
            showCreatorData={showCreatorData}
            creatorData={creatorData}
            onDelete={this.removeCreatorFromWheelHandler}
            wheelSlug={wheelData.slug}
            handleLoadWheel={this.handleLoadWheel}
            fetchCreatorService={this.fetchCreatorService}
          />
        </SideContainer>
        <Modal
          theme_modal_border
          isShow={isModal}
          handleClickCloseModal={this.handleClickCloseModal}
        >
          <div>
            <CreatorServiceForm
              handleSave={this.handleCreateService}
              handleCancel={this.handleClickCloseModal}
              options={dataServiceList}
            />
          </div>
        </Modal>
      </WheelContainerStyled>
    );
  }
}

const ImageWithPreload = ({ src }) => {
  const [loading, setIsLoading] = useState(true);
  return (
    <ImagePreloadContainer>
      {loading && <div className="preload">loading</div>}
      <img src={src} alt="genre" onLoad={() => setIsLoading(false)} />
    </ImagePreloadContainer>
  );
};

const mapStateToProps = (state) => ({
  authRedux: state.auth,
  reduxForm: state.form.WheelProfileForm,
  reduxForm2: state.form.CreatorServiceForm,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WheelContainer);
